{
  "name": "22-(37to47) < 256°",
  "description": "22-tone Rational Intonation gamut, consisting of pitch classes derived from odd harmonic partials not exceeding 256° and comprising only products of primes <= 47. This set is a subset of the preceding pitches, including primes 37 through 47 and the pitch classes 1°, 3°, 9°, 27°, 7°, 21°, 63°. The high primes all have their 5 identities.",
  "scale": [
    "129/128",
    "141/128",
    "9/8",
    "147/128",
    "37/32",
    "41/32",
    "21/16",
    "43/32",
    "185/128",
    "47/32",
    "3/2",
    "49/32",
    "205/128",
    "215/128",
    "27/16",
    "111/64",
    "7/4",
    "235/128",
    "245/128",
    "123/64",
    "63/32",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "OddPart(37to47)",
  "built_in_group": "Odd Partial Pitch Class Sets",
  "key_labels": "note_names",
  "note_names": [
    "1",
    "129",
    "141",
    "9",
    "147",
    "37",
    "41",
    "21",
    "43",
    "185",
    "47",
    "3",
    "49",
    "205",
    "215",
    "27",
    "111",
    "7",
    "235",
    "245",
    "123",
    "63"
  ],
  "note_colors": [
    "#ff8888",
    "#c9a573",
    "#ffb8da",
    "#ffffff",
    "#f8c9c9",
    "#cee3e2",
    "#f89b87",
    "#ffe5e5",
    "#c9a573",
    "#dfebdb",
    "#ffb8da",
    "#ffffff",
    "#f8c9c9",
    "#e0b49e",
    "#e8c28c",
    "#ffffff",
    "#cee3e2",
    "#ffe5e5",
    "#f79cc5",
    "#ffb59a",
    "#f89b87",
    "#ffe5e5"
  ],
  "equivSteps": 22,
  "fundamental": 440,
  "reference_degree": 15,
  "center_degree": 0,
  "rSteps": 4,
  "drSteps": 1,
  "hexSize": 38,
  "rotation": -16.102113751
}
